<template>
  <div>
    <h2 class="text-center mb-4">Prospect data summary:</h2>

    <!--  health info:   -->

    <div>
      <h3>Health Notes:</h3>

      <ul>
        <li v-for="(key, k) in selectedDisease" :key="k">
          {{ diseaseDetails(key) }}
        </li>
      </ul>
    </div>

    <!--  needs info:   -->

    <div class="mt-4">
      <h3>Main need:</h3>

      <div v-if="needsList && needsList.length > 0">
        <div v-for="(type, k) in needsList" :key="k">
          {{ needTextByType(type, needs[type]) }}
        </div>
      </div>
    </div>

    <!--  banking info:   -->

    <div class="mt-4">
      <h3>Banking info:</h3>

      <div v-if="bankDetails.isDraft">
        <div>Bank draft</div>
        <div class="ml-4">
          <div>
            <span class="font-weight-bold">Name of the bank: </span>
            <span class="body-1">{{ bankDetails.draft.name }}</span>
          </div>

          <div>
            <span class="font-weight-bold">Routing number: </span>
            <span class="body-1">{{ bankDetails.draft.routing }}</span>
          </div>

          <div>
            <span class="font-weight-bold">Account number: </span>
            <span class="body-1">{{ bankDetails.draft.account }}</span>
          </div>
        </div>
      </div>
      <div v-else>
        <div>Debit/credit</div>
        <div class="ml-4">
          <div>
            <span class="font-weight-bold">Card number: </span>
            <span class="body-1">{{ bankDetails.card.card }}</span>
          </div>

          <div class="d-flex" style="gap: 20px">
            <div>
              <span class="font-weight-bold">MM: </span>
              <span class="body-1">{{ bankDetails.card.expirationMonth }}</span>
            </div>

            <div>
              <span class="font-weight-bold">YY: </span>
              <span class="body-1">{{ bankDetails.card.expirationYear }}</span>
            </div>
          </div>

          <div>
            <span class="font-weight-bold">Security code: </span>
            <span class="body-1">{{ bankDetails.card.security }}</span>
          </div>

          <div>
            <span class="font-weight-bold">Billing Zip Code: </span>
            <span class="body-1">{{ bankDetails.card.zip }}</span>
          </div>
        </div>
      </div>
    </div>

    <!--  basic info:   -->

    <div class="mt-4">
      <h3>Basic info:</h3>

      <div class="ml-4">
        <div>
          <span class="font-weight-bold">Name: </span>
          <span class="body-1">{{ lead.fullname }}</span>
        </div>

        <div>
          <span class="font-weight-bold">Date of Birth: </span>
          <span class="body-1">{{
            format(new Date(lead.birth_date), 'MM-dd-yyyy')
          }}</span>
        </div>

        <div>
          <span class="font-weight-bold">Height: </span>
          <span class="body-1">{{ lead.height }}</span>
        </div>

        <div>
          <span class="font-weight-bold">Weight: </span>
          <span class="body-1">{{ lead.weight }}</span>
        </div>
      </div>
    </div>

    <!--  beni info:  -->

    <div class="mt-4">
      <h3>Beneficiary info:</h3>
      <div>{{ beneficiaryDetails }}</div>
    </div>

    <PlateFooter :onBack="onBack" lastStep />
  </div>
</template>

<script>
import PlateFooter from '@/components/lead/plates/PlateFooter';
import { PlatesSteps } from '@/common/variables';
import { mapGetters } from 'vuex';
import { diseaseTextByType, needTextByType } from '@/common/helpers';
import { format } from 'date-fns';

export default {
  name: 'SummaryPlate',
  components: { PlateFooter },
  computed: {
    ...mapGetters({
      bankDetails: 'plates/bankDetails',
      disease: 'plates/disease',
      selectedDisease: 'plates/selectedDisease',
      needs: 'plates/needs',
      needsList: 'plates/needsList',
    }),

    beneficiaryDetails() {
      //Todo remove after make dynamic beni
      const isLiveInSameState = this.beneficiary.liveInSameState
        ? `Leaves in ${this.lead.state}`
        : 'Leaves out of state';

      const isAnyGrandchildren = this.beneficiary.grandchildrenAmount
        ? `- ${this.beneficiary.grandchildrenAmount} Grandkids`
        : '';

      const nonSpouseText =
        this.beneficiary.relationship !== 'spouse'
          ? `- ${isLiveInSameState} ${isAnyGrandchildren}`
          : '';

      return `${this.beneficiary.relationship} - ${this.beneficiary.name} ${nonSpouseText}`;
    },
  },
  props: {
    lead: {
      type: Object,
    },
    beneficiary: {
      type: Object,
    },
  },
  methods: {
    diseaseDetails(type) {
      return diseaseTextByType(type, this.disease[type]);
    },
    onBack() {
      this.$store.commit('plates/setStep', PlatesSteps.payment);
    },

    needTextByType,
    format,
  },
};
</script>

<style scoped lang="scss"></style>
